const isDev = import.meta.env.DEV;

// Make sure to have the same port as the one you set in process.env.PORT

const API_URL = isDev
  ? "https://localhost:8080"
  : "https://api.ocartedespre.ro";

const config = {
  API_URL,
  CDN_URL: `${API_URL}/cdn`,
  CDN_RESIZED_IMAGES_PATH: `${API_URL}/cdn/images/api/books/ocartedespre/assets/pages/resized`,
  API_PREVIEW_TIMEOUT: 500,
  MIN_PASSWORD_LENGTH: 8,
  ANALYTICS_WINDOW_EVENT_NAME: "ocd_analytics",
};

export default config;
